import { LitElement, html, css } from 'lit';
import { customElement } from 'lit/decorators';

@customElement('folder-card')
export class FolderCard extends LitElement {
    protected render() {
        return html`
            <div class="folderCard">
                <mwc-icon class="folderIcon">folder</mwc-icon>
                <slot></slot>
            </div>
        `;
    }

    static get styles() {
        return css`
            .folderIcon {
                margin-right: 1.5rem;
                font-size: 2rem;
            }

            .folderCard {
                display: flex;
                align-items: center;
                padding: 1.5rem 2rem;
                margin: 0.5rem;
                border-radius: 0.75rem;
                overflow: hidden;
                cursor: pointer;
                background: var(--theme-white-color);
                box-shadow: 0px 2px 2px -2px rgba(31, 27, 45, 0.08),
                    0px 4px 12px rgba(31, 27, 45, 0.08);
            }
        `;
    }
}
